import NoResultsFoundSVG from "@assets/images/No-Results-Found.svg";
import { IconButton, TableCell, TableRow } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { ClassNameMap } from "@material-ui/styles/withStyles";
import {
  ExpressFleetMallsConfig_malls_edges_node,
  ExpressFleetMallsConfigVariables
} from "@saleor/autobooking/types/ExpressFleetMallsConfig";
import { maybe } from "@saleor/misc";
import React, { Dispatch, SetStateAction } from "react";

import CircularLoading from "../CircularLoading";
import TableCellStatus from "./TableCellStatus";

export interface TableBodyContentProps {
  tblClasses: ClassNameMap<string>;
  numberOfColumns: number;
  isLoading: boolean;
  dataList: ExpressFleetMallsConfig_malls_edges_node[];
  refetch: (variables?: ExpressFleetMallsConfigVariables) => any;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  selectedMall: ExpressFleetMallsConfig_malls_edges_node;
  setSelectedMall: React.Dispatch<
    React.SetStateAction<ExpressFleetMallsConfig_malls_edges_node>
  >;
  activeTab: string;
}

const TableBodyContent: React.FC<TableBodyContentProps> = props => {
  const {
    tblClasses,
    numberOfColumns,
    isLoading,
    dataList,
    setOpenModal,
    setSelectedMall,
    activeTab
  } = props;

  const getTableBodyContentToRender = () => {
    let contentToRender;

    if (isLoading) {
      contentToRender = (
        <TableRow>
          <TableCell colSpan={numberOfColumns}>
            <CircularLoading />
          </TableCell>
        </TableRow>
      );
    } else if (!isLoading && dataList?.length === 0) {
      contentToRender = (
        <TableRow>
          <TableCell
            colSpan={numberOfColumns}
            className={tblClasses.tableCellHeaderMallSearchNoResults}
          >
            <img src={NoResultsFoundSVG} alt="" />
            <p>
              No SM Mall found with that name. Please check the spelling and try
              again.
            </p>
          </TableCell>
        </TableRow>
      );
    } else {
      contentToRender = (
        <>
          {dataList?.map((mall, index) => (
            <TableRow
              key={mall.id}
              className={`${(index + 1) % 2 === 0 ? tblClasses.itemsOdd : ""}`}
            >
              <TableCell
                className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
              >
                <div>
                  <div className={tblClasses.dataTitle}>Mall</div>
                  <div>
                    {maybe(() => mall.name) ? <span>{mall.name}</span> : "-"}
                  </div>
                </div>
              </TableCell>
              {activeTab === "fnb" ? (
                <>
                  <TableCellStatus
                    label="Default Courier"
                    value={mall?.fbAutoBookingConfig?.courier?.replace(
                      /_/g,
                      " "
                    )}
                  />
                  <TableCellStatus
                    label="All Ready Status"
                    value={mall?.fbAutoBookingConfig?.readyStatusMinutes}
                  />
                  <TableCellStatus
                    label="All Collected Status"
                    value={mall?.fbAutoBookingConfig?.collectedStatusMinutes}
                  />
                  <TableCellStatus
                    label="Any Status"
                    value={mall?.fbAutoBookingConfig?.anyStatusMinutes}
                  />
                  <TableCellStatus
                    label="Auto-booking"
                    value={
                      mall?.fbAutoBookingConfig?.isEnabled
                        ? "ACTIVE"
                        : "INACTIVE"
                    }
                    textClass={
                      mall?.fbAutoBookingConfig?.isEnabled === true
                        ? tblClasses.activeStatusText
                        : tblClasses.inactiveStatusText
                    }
                  />
                  <TableCell
                    className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
                  >
                    <div>
                      <div className={tblClasses.dataTitle}>Edit</div>
                      <div>
                        <IconButton
                          color="primary"
                          onClick={() => {
                            setSelectedMall(mall);
                            setOpenModal(true);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </div>
                    </div>
                  </TableCell>
                </>
              ) : (
                <>
                  <TableCellStatus
                    label="Default Courier"
                    value={mall?.gmAutoBookingConfig?.courier?.replace(
                      /_/g,
                      " "
                    )}
                  />
                  <TableCellStatus
                    label="All Ready Status"
                    value={mall?.gmAutoBookingConfig?.readyStatusMinutes}
                  />
                  <TableCellStatus
                    label="All Collected Status"
                    value={mall?.gmAutoBookingConfig?.collectedStatusMinutes}
                  />
                  <TableCellStatus
                    label="Any Status"
                    value={mall?.gmAutoBookingConfig?.anyStatusMinutes}
                  />
                  <TableCellStatus
                    label="Auto-booking"
                    value={
                      mall?.gmAutoBookingConfig?.isEnabled
                        ? "ACTIVE"
                        : "INACTIVE"
                    }
                    textClass={
                      mall?.gmAutoBookingConfig?.isEnabled === true
                        ? tblClasses.activeStatusText
                        : tblClasses.inactiveStatusText
                    }
                  />
                  <TableCell
                    className={`${tblClasses.tableCellBody} ${tblClasses.colStatus}`}
                  >
                    <div>
                      <div className={tblClasses.dataTitle}>Edit</div>
                      <div>
                        <IconButton
                          color="primary"
                          onClick={() => {
                            setSelectedMall(mall);
                            setOpenModal(true);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </div>
                    </div>
                  </TableCell>
                </>
              )}
            </TableRow>
          ))}
        </>
      );
    }
    return contentToRender;
  };

  return getTableBodyContentToRender();
};

export default TableBodyContent;
